import { mapData } from "@/utilities/DataMapping";

export interface ISouthEasternFieldSet {

    ramsReference: string;

    isConfinedSpace: boolean;
    confinedSpaceIsPersonnelTrained: boolean;
    confinedSpaceIsNotWorkingAlone: boolean;
    confinedSpaceIsTopMan: boolean;
    confinedSpaceIsHarness: boolean;
    confinedSpaceIsRadio: boolean;
    confinedSpaceIsGasMonitor: boolean;
    confinedSpaceIsBumpCap: boolean;
    confinedSpaceIsSafetyFootwear: boolean;
    confinedSpaceIsSafetyGlasses: boolean;
    confinedSpaceIsOther: boolean;
    confinedSpaceOther: string;
    confinedSpaceEmergency: string;

    isWorkingAtHeight: boolean;
    workingAtHeightArePersonnelTrained: boolean;
    workingAtHeightIsHarness: boolean;
    workingAtHeightIsBumpCap: boolean;
    workingAtHeightIsSafetyGlasses: boolean;
    workingAtHeightIsSafetyFootwear: boolean;
    workingAtHeightOther: string;
    workingAtHeightIsOther: boolean;
    workingAtHeightEmergency: string;

    isHotWorks: boolean;
    hotWorksAreaIsClearedOfCombustibles: boolean;
    hotWorksIsProtectionForUnmovableItems: boolean;
    hotWorksIsFireExtinguishers: boolean;
    hotWorksIsCompetentStaff : boolean;
    hotWorksIsFireWatchman: boolean;
    hotWorksIsFireDetectionIsolated: boolean;
    hotWorksZoneNumber: string;
    hotWorksAspiratorNo: string;
    hotWorksAddressNumber: string;

    isIsolationRequired: boolean;
    isolationRequiredZoneNumber: string;
    isolationRequiredAspiratorNo: string;
    isolationRequiredAddressNumber: string;
    isolationRequiredLvPanelSwitchNo: string;
    isolationRequiredDistributionBoardNo: string;
    isolationRequiredCircuitMcbRef: string;
    isolationRequiredPlantIdNo: string;
    isolationRequiredMainSystem: string;
    isolationRequiredSubSystem: string;
    isolationRequiredLockOfPoint: string;

    primaryLocation: string;
    secondaryLocation: string;
    locationNotes: string;
}

export class SouthEasternFieldSet implements ISouthEasternFieldSet {

    constructor(data?: any) {
        if (data) this.update(data);
    }

    update(data: any): ISouthEasternFieldSet {
        if(data) mapData(data, {
            root: () => this
        });
        return this;
    }

    ramsReference: string = "";

    isConfinedSpace: boolean = false;
    confinedSpaceIsPersonnelTrained: boolean = false;
    confinedSpaceIsNotWorkingAlone: boolean = false;
    confinedSpaceIsTopMan: boolean = false;
    confinedSpaceIsHarness: boolean = false;
    confinedSpaceIsRadio: boolean = false;
    confinedSpaceIsGasMonitor: boolean = false;
    confinedSpaceIsBumpCap: boolean = false;
    confinedSpaceIsSafetyFootwear: boolean = false;
    confinedSpaceIsSafetyGlasses: boolean = false;
    confinedSpaceIsOther: boolean = false;
    confinedSpaceOther: string = "";
    confinedSpaceEmergency: string = "";

    isWorkingAtHeight: boolean = false;
    workingAtHeightArePersonnelTrained: boolean = false;
    workingAtHeightIsHarness: boolean = false;
    workingAtHeightIsBumpCap: boolean = false;
    workingAtHeightIsSafetyGlasses: boolean = false;
    workingAtHeightIsSafetyFootwear: boolean = false;
    workingAtHeightIsOther: boolean = false;
    workingAtHeightOther: string = "";
    workingAtHeightEmergency: string = "";

    isHotWorks: boolean = false;
    hotWorksAreaIsClearedOfCombustibles: boolean = false;
    hotWorksIsProtectionForUnmovableItems: boolean = false;
    hotWorksIsFireExtinguishers: boolean = false;
    hotWorksIsCompetentStaff : boolean = false;
    hotWorksIsFireWatchman: boolean = false;
    hotWorksIsFireDetectionIsolated: boolean = false;
    hotWorksZoneNumber: string = "";
    hotWorksAspiratorNo: string = "";
    hotWorksAddressNumber: string = "";

    isIsolationRequired: boolean = false;
    isolationRequiredZoneNumber: string = "";
    isolationRequiredAspiratorNo: string = "";
    isolationRequiredAddressNumber: string = "";
    isolationRequiredLvPanelSwitchNo: string = "";
    isolationRequiredDistributionBoardNo: string = "";
    isolationRequiredCircuitMcbRef: string = "";
    isolationRequiredPlantIdNo: string = "";
    isolationRequiredMainSystem: string = "";
    isolationRequiredSubSystem: string = "";
    isolationRequiredLockOfPoint: string = "";

    primaryLocation: string = "";
    secondaryLocation: string = "";
    locationNotes: string = "";
}
